import axios from 'axios'

export const getCompanies = (params) =>
    axios.get('companies', params)
        .then(({ data }) => data)

export const getCompanyView = (slug) =>
    axios.get(`companies/${slug}`)
        .then(({ data }) => data)

export const getCompanyNews = (slug, params) =>
    axios.get(`companies/${slug}/articles`, params)
        .then(({ data }) => data)

export const getCompanyResearchReport = (slug, researchSlug) =>
    axios.get(`companies/${slug}/research/${researchSlug}`)
        .then(({ data }) => data)

export const getAusIqCompanySummary = (ticker) =>
    axios.get(`companies/${ticker}/ausiq/summary`)
        .then(({ data }) => data)

export const getAusIqIqCash = (ticker) =>
    axios.get(`companies/${ticker}/ausiq/iq-cash`)
        .then(({ data }) => data)

export const getAusIqMiningProjects = (ticker) =>
    axios.get(`companies/${ticker}/ausiq/mining-projects`)
        .then(({ data }) => data)

export const getAusIqOptions = (ticker) =>
    axios.get(`companies/${ticker}/ausiq/options`)
        .then(({ data }) => data)
